exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TimerBar-module__wrapper___1l85e{width:600px;max-width:calc(100vw - 250px)}", ""]);

// exports
exports.locals = {
	"wrapper": "TimerBar-module__wrapper___1l85e"
};